import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { Statistic2States } from '@fi-app/statistic2/statistic2-states';
import { Statistic2ReportParameterListComponent } from './statistic2-report-parameter-list/statistic2-report-parameter-list.component';
import { Statistic2ReportParameterEditModule } from '@fi-app/statistic2/statistic2-report-parameter-edit/statistic2-report-parameter-edit.module';
import { Statistic2Service } from '@fi-app/statistic2/statistic2.service';
import { Statistic2DashboardModule } from '@fi-app/statistic2/statistic2-dashboard/statistic2-dashboard.module';
import { Statistic2HelperService } from '@fi-app/statistic2/statistic2-helper.service';
import { Statistic2HeaderModule } from '@fi-app/statistic2/statistic2-header/statistic2-header.module';
import { ItemsListModule } from '@fi-app/components/items-list/items-list.module';
import { Statistic2ReportService } from '@fi-app/statistic2/statistic2-report.service';
import { Statistic2ReportListComponent } from './statistic2-report-parameter-list/statistic2-report-list.component';
import { FiLocalSearch2Module } from '@fi-app/shared/fi-local-search2/fi-local-search2.module';
import { FiWrapperTableModule } from '@fi-app/shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatCardModule } from '@angular/material/card';
import { FiItemsListModule } from '@fi-app/shared/fi-items-list/fi-items-list.module';
import { FiWhenScrolledModule } from '@fi-app/shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild(Statistic2States),
        ItemsListModule,
        Statistic2ReportParameterEditModule,
        Statistic2DashboardModule,
        Statistic2HeaderModule,
        FiLocalSearch2Module,
        FiWrapperTableModule,
        MatCardModule,
        FiItemsListModule,
        FiWhenScrolledModule,
        FiAppTextSharedModule
    ],
    declarations: [Statistic2ReportParameterListComponent, Statistic2ReportListComponent],
    providers: [Statistic2Service, Statistic2ReportService, Statistic2HelperService],
})
export class Statistic2Module {}
